//引入AxiosReques
import axiosApi from '@/utils/AxiosReques'

/**
 * @description 创建申请案件
 * @returns Promise
 * @params id
 */
export const addApplyCase = (params) => axiosApi.post(`/api/Proxy/addApplyCase`, params)

/**
 * @description 获取国家名称
 * @returns Promise
 * @params id
 */
export const getCountry = (params) => axiosApi.post(`/api/Proxy/getCountry`, params)

/**
 * @description 获取案件列表
 * @returns Promise
 * @params id
 */
export const getApplyCaseList = (params) => axiosApi.post(`/api/Proxy/getApplyCaseList?p=${params.page}`, params)

/**
 * @description 获取案件详情
 * @returns Promise
 * @params id
 */
export const getcaseDetails = (params) => axiosApi.post(`/api/Proxy/caseDetails`, params)

/**
 * @description 获取资料统计
 * @returns Promise
 * @params id
 */
export const DetailsAnnexCount = (params) => axiosApi.post(`/api/Proxy/DetailsAnnexCount`, params)

/**
 * @description 添加申请人附件
 * @returns Promise
 * @params id
 */
export const addCaseAnnex = (params) => axiosApi.post(`/api/Proxy/addCaseAnnex`, params)

/**
 * @description 查询申请人附件
 * @returns Promise
 * @params id
 */
export const getShowAnnex = (params) => axiosApi.post(`/api/Proxy/getShowAnnex`, params)

/**
 * @description 删除附件
 * @returns Promise
 * @params id
 */
export const delCaseAnnex = (params) => axiosApi.post(`/api/Proxy/delCaseAnnex`, params)

/**
 * @description 确认无误
 * @returns Promise
 * @params id
 */
export const annexConfirm = (params) => axiosApi.post(`/api/Proxy/annexConfirm`, params)

/**
 * @description //累计通知文书查看次数（客户端）
 * @returns Promise
 * @params id
 */
export const setshows = (params) => axiosApi.post(`/api/Proxy/setshows`, params)

/**
 * @description 获取账单列表
 * @returns Promise
 */
export const getBill = (params) => axiosApi.post(`/api/Bill/getBill?p=${params.page}`, params)

/**
 * @description 获取账单列表
 * @returns Promise
 */
export const getshowbills = (params) => axiosApi.post(`/api/Bill/getshowbills?p=${params.page}`, params)

/**
 * @description 删除案件
 * @returns Promise
 */
export const delApplyCase = (params) => axiosApi.post(`/api/Proxy/delApplyCase`, params)

/**
 * @description 查询公文包列表
 * @returns Promise
 */
export const setFile = (params) => axiosApi.post(`/api/Proxy/setFile?p=${params.page}`, params)

/**
 * @description 从公文包添加文件
 * @returns Promise
 */
export const addMyfile = (params) => axiosApi.post(`/api/Proxy/addMyfile`, params)

/**
 * @description 从公文包添加文件
 * @returns Promise
 */
export const Briefcase = (params) => axiosApi.post(`/api/Briefcase/index?p=${params.page}`, params)

/**
 * @description 从公文包删除文件
 * @returns Promise
 */
export const delMyfile = (params) => axiosApi.post(`/api/Briefcase/delMyfile?p=${params.page}`, params)

/**
 * @description 在公文包添加文件
 * @returns Promise
 */
export const addMyfiles = (params) => axiosApi.post(`/api/Briefcase/addMyfile`, params)

/**
 * @description 修改文件名称
 * @returns Promise
 */
export const editFileName = (params) => axiosApi.post(`/api/Briefcase/editFileName`, params)

/**
 * @description 通知中心
 * @returns Promise
 */
export const Document = (params) => axiosApi.post(`/api/Document/index?p=${params.page}`, params)

/**
 * @description 确认中心
 * @returns Promise
 */
export const Confirm = (params) => axiosApi.post(`/api/Confirm/index?p=${params.page}`, params)

/**
 * @description 确认中心
 * @returns Promise
 */
export const getCountData = (params) => axiosApi.post(`/api/Proxy/getCountData`, params)

/**
 * @description 账单支付
 * @returns Promise
 */
export const Billpay = (params) => axiosApi.post(`/api/Bill/pay`, params)

/**
 * @description 账单支付
 * @returns Promise
 */
export const askPay = (params) => axiosApi.post(`/api/Bill/askPay`, params)

/**
 * @description 获取支付凭证
 * @returns Promise
 */
export const getPayVoucher = (params) => axiosApi.post(`/api/Bill/getPayVoucher`, params)

/**
 * @description 获取代报中心轮播图
 * @returns Promise
 */
export const getProxyImg = (params) => axiosApi.post(`/api/Proxy/getProxyImg`, params)

/**
 * @description 创建【费用代缴】案件
 * @returns Promise
 */
export const addFeeCase = (params) => axiosApi.post(`/api/Proxy/addFeeCase`, params)

/**
 * @description 获取专利【费用】代缴明细
 * @returns Promise
 */
export const getFeeAgentList = (params) => axiosApi.post(`/api/Proxy/getFeeAgentList?p=${params.page}`, params)

/**
 * @description  查询专利
 * @returns Promise
 */
export const getFeeAgent = (params) => axiosApi.get(`/api/Proxy/editFeeAgent?p=${params.page}`, params)

/**
 * @description 修改专利
 * @returns Promise
 */
export const editFeeAgent = (params) => axiosApi.post(`/api/Proxy/editFeeAgent?p=${params.page}`, params)

/**
 * @description 修改专利
 * @returns Promise
 */
export const delFeeAgent = (params) => axiosApi.post(`/api/Proxy/delFeeAgent?p=${params.page}`, params)

/**
 * @description 专利从已确认文案选择
 * @returns Promise
 */
export const selectCopywritingApply = (params) => axiosApi.post(`/api/Proxy/selectCopywritingApply`, params)

/**
 * @description 创建【文案】撰写
 * @returns Promise
 */
export const addCopywriting = (params) => axiosApi.post(`/api/Proxy/addCopywriting?p=${params.page}`, params)

/**
 * @description 创建【文案】撰写
 * @returns Promise
 */
export const getCopywritingList = (params) => axiosApi.post(`/api/Proxy/getCopywritingList?p=${params.page}`, params)

/**
 * @description 修改文案单条
 * @returns Promise
 */
export const editCopywriting = (params) => axiosApi.post(`/api/Proxy/editCopywriting?p=${params.page}`, params)

/**
 * @description  获取文案单条
 * @returns Promise
 */
export const getCopywriting = (params) => axiosApi.get(`/api/Proxy/editCopywriting?p=${params.page}`, params)

/**
 * @description  获取文案单条
 * @returns Promise
 */
export const delCopywriting = (params) => axiosApi.post(`/api/Proxy/delCopywriting?p=${params.page}`, params)

/**
 * @description  【文案】详情 
 * @returns Promise
 */
export const getCopywritingDetails = (params) => axiosApi.post(`/api/Proxy/getCopywritingDetails?p=${params.page}`, params)

/**
 * @description  添加【文案】原始材料
 * @returns Promise
 */
export const addCopywritingAnnex = (params) => axiosApi.post(`/api/Proxy/addCopywritingAnnex?p=${params.page}`, params)

/**
 * @description  获取【文案】附件
 * @returns Promise
 */
export const getCopywritingAnnex = (params) => axiosApi.post(`/api/Proxy/getCopywritingAnnex?p=${params.page}`, params)

/**
 * @description  删除【文案】附件
 * @returns Promise
 */
export const delCopywritingAnnex = (params) => axiosApi.post(`/api/Proxy/delCopywritingAnnex?p=${params.page}`, params)

/**
 * @description  删除【文案】统计
 * @returns Promise
 */
export const getCopywritingAnnexCount = (params) => axiosApi.post(`/api/Proxy/getCopywritingAnnexCount?p=${params.page}`, params)

/**
 * @description  创建【答辩/复审】申报
 * @returns Promise
 */
export const addOa = (params) => axiosApi.post(`/api/Proxy/addOa?p=${params.page}`, params)

/**
 * @description  获取【答辩/复审】申报列表
 * @returns Promise
 */
export const getOaList = (params) => axiosApi.post(`/api/Proxy/getOaList?p=${params.page}`, params)

/**
 * @description  获取答辩/复审单条
 * @returns Promise
 */
export const geteditOa = (params) => axiosApi.get(`/api/Proxy/editOa?p=${params.page}`, params)

/**
 * @description 修改答辩/复审
 * @returns Promise
 */
export const editOa = (params) => axiosApi.post(`/api/Proxy/editOa?p=${params.page}`, params)

/**
 * @description 获取详情答辩/复审
 * @returns Promise
 */
export const getOaDetails = (params) => axiosApi.post(`/api/Proxy/getOaDetails?p=${params.page}`, params)

/**
 * @description 获取详情答辩/复审
 * @returns Promise
 */
export const delOa = (params) => axiosApi.post(`/api/Proxy/delOa?p=${params.page}`, params)

/**
 * @description 添加【答辩/复审】申报材料
 * @returns Promise
 */
export const addOaAnnex = (params) => axiosApi.post(`/api/Proxy/addOaAnnex?p=${params.page}`, params)

/**
 * @description 删除【答辩/复审】附件
 * @returns Promise
 */
export const delOaAnnex = (params) => axiosApi.post(`/api/Proxy/delOaAnnex?p=${params.page}`, params)

/**
 * @description 【答辩/复审】打开【已确认的文案】
 * @returns Promise
 */
export const getCopywritingInfo = (params) => axiosApi.post(`/api/Proxy/getCopywritingInfo?p=${params.page}`, params)

/**
 * @description 【【答辩/复审】选择【已确认的文案】
 * @returns Promise
 */
export const selectCopywriting = (params) => axiosApi.post(`/api/Proxy/selectCopywriting?p=${params.page}`, params)

/**
 * @description 获取【答辩/复审】附件
 * @returns Promise
 */
export const getOaAnnex = (params) => axiosApi.post(`/api/Proxy/getOaAnnex?p=${params.page}`, params)

/**
 * @description 获取【答辩/复审】类型统计数据
 * @returns Promise
 */
export const getOaAnnexCount = (params) => axiosApi.post(`/api/Proxy/getOaAnnexCount?p=${params.page}`, params)

/**
 * @description 创建中间案件
 * @returns Promise
 */
export const addMiddle = (params) => axiosApi.post(`/api/Proxy/addMiddle?p=${params.page}`, params)

/**
 * @description 获取中间案件列表
 * @returns Promise
 */
export const getMiddleList = (params) => axiosApi.post(`/api/Proxy/getMiddleList?p=${params.page}`, params)

/**
 * @description 获取中间案件单条
 * @returns Promise
 */
export const getMiddle = (params) => axiosApi.get(`/api/Proxy/editMiddle?p=${params.page}`, params)

/**
 * @description 修改中间案件
 * @returns Promise
 */
export const editMiddle = (params) => axiosApi.post(`/api/Proxy/editMiddle?p=${params.page}`, params)

/**
 * @description 删除中间案件
 * @returns Promise
 */
export const delMiddle = (params) => axiosApi.post(`/api/Proxy/delMiddle?p=${params.page}`, params)

/**
 * @description 获取中间案件详情
 * @returns Promise
 */
export const getMiddleDetails = (params) => axiosApi.post(`/api/Proxy/getMiddleDetails?p=${params.page}`, params)

/**
 * @description 添加中间案件附件
 * @returns Promise
 */
export const addMiddleAnnex = (params) => axiosApi.post(`/api/Proxy/addMiddleAnnex?p=${params.page}`, params)

/**
 * @description 删除中间案件附件
 * @returns Promise
 */
export const delMiddleAnnex = (params) => axiosApi.post(`/api/Proxy/delMiddleAnnex?p=${params.page}`, params)

/**
 * @description 获取中间案件附件列表
 * @returns Promise
 */
export const getMiddleAnnex = (params) => axiosApi.post(`/api/Proxy/getMiddleAnnex?p=${params.page}`, params)

/**
 * @description 获取中间案件附详情中分类统计
 * @returns Promise
 */
export const getMiddleAnnexCount = (params) => axiosApi.post(`/api/Proxy/getMiddleAnnexCount?p=${params.page}`, params)

/**
 * @description 通知文书标记已读
 * @returns Promise
 */
export const setRead = (params) => axiosApi.post(`/api/Document/setRead?p=${params.page}`, params)

/**
 * @description 获取结算明细
 * @returns Promise
 */
export const getSettlementDetails = (params) => axiosApi.post(`/api/Bill/getSettlementDetails?p=${params.page}`, params)

/**
 * @description 获取结算明细
 * @returns Promise
 */
export const getSignInfo = (params) => axiosApi.post(`/api/Getinfo/getSignInfo?p=${params.page}`, params)

/**
 * @description 添加标识卡
 * @returns Promise
 */
export const addSignInfo = (params) => axiosApi.post(`/api/Getinfo/addSignInfo`, params)

/**
 * @description 修改标识卡
 * @returns Promise
 */
export const editSignInfo = (params) => axiosApi.post(`/api/Getinfo/editSignInfo`, params)
